import React from 'react';
import { useState, useEffect } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { Conversation } from './components/DataDefinitions';
import AIChatProvider from 'pages/ai_assistant/components/AIChatProvider';
import AIChatSidebar from './components/AIChatSidebar';
import AIChatHomepageCard from './components/AIChatHomepage';
import { Card, Col, Row } from 'react-bootstrap';

const AIAssistant: React.FC<{ title: string }> = ({ title }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [conversations, setConversations] = useState<Conversation[]>([]);


    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('AI assistant'),
            active: true
        }
    ];

    const fetchData = async () => {
        try {
            const response = await apiClient.get(
                '/v1/va',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setConversations(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);



    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <Card className='border border-light rounded-5 mt-3'>
                <Card.Body>
                    <AIChatProvider conversations={conversations}>
                        <div className="chat d-flex gap-3">
                            <AIChatHomepageCard />
                            <AIChatSidebar />
                        </div>
                    </AIChatProvider>
                </Card.Body>
            </Card>

            <Card className='border border-light rounded-5 mt-4 mb-4' >
                <Card.Body>
                    <h3 className='mb-4'>{t('iva.intro')}</h3>
                    <Row>
                        <Col md={4} xl={4} className="d-none d-md-block">
                            <h4>{t('iva.whatMakesSpecial')}</h4>
                            <ul>
                                <li>{t('iva.specialFeatures.privateKnowledgeBase')}</li>
                                <li>{t('iva.specialFeatures.secureAccess')}</li>
                                <li>{t('iva.specialFeatures.institutionalMemory')}</li>
                                <li>{t('iva.specialFeatures.domainExpert')}</li>
                            </ul>
                        </Col>
                        <Col md={4} xl={4} className="d-none d-md-block">
                            <h4>{t('iva.howDifferent')}</h4>
                            <ul>
                                <li>{t('iva.differences.specificProcesses')}</li>
                                <li>{t('iva.differences.understandsTerminology')}</li>
                                <li>{t('iva.differences.referencesDocs')}</li>
                                <li>{t('iva.differences.consistentResponses')}</li>
                            </ul>
                        </Col>
                        <Col md={4} xl={4} className="d-none d-md-block">

                            <h4>{t('iva.perfectFor.intro')}</h4>
                            <ul>
                                <li>{t('iva.perfectFor.policyQuestions')}</li>
                                <li>{t('iva.perfectFor.companyProcedures')}</li>
                                <li>{t('iva.perfectFor.projectReferences')}</li>
                                <li>{t('iva.perfectFor.bestPractices')}</li>
                                <li>{t('iva.perfectFor.onboardingSupport')}</li>
                            </ul>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </>
    );
};

export default AIAssistant;
